<h1 class="h2 mb-4">Profil & facturare</h1>
<!-- Profile -->
<section class="card border-0 py-1 p-md-2 p-xl-3 p-xxl-4 mb-4">
  <div class="card-body">
    <div class="d-flex align-items-center mt-sm-n1 pb-4 mb-0 mb-lg-1 mb-xl-3">
      <i class="ai-user text-primary lead pe-1 me-2"></i>
      <h2 class="h4 mb-0">Profil</h2>
    </div>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>

      <div class="d-sm-flex align-items-top">
        <div class="d-flex align-items-center">
          <div ngbDropdown class="dropdown">
            <a ngbDropdownToggle
              class="d-flex flex-column justify-content-end position-relative overflow-hidden rounded-circle bg-size-cover bg-position-center flex-shrink-0 remove-caret"
              aria-expanded="false" style="width: 80px; height: 80px; background-image: url({{editedImage}});"
              role="button">
              <span class="d-block text-light text-center lh-1 pb-1" style="background-color: rgba(0,0,0,.5)"><i
                  class="ai-camera"></i></span>
            </a>
            <div ngbDropdownMenu class="dropdown-menu my-1">
              <a (click)="onUploadImageClick(imageModalTemplate)" ngbDropdownItem class="dropdown-item fw-normal"
                role="button"><i class="ai-camera fs-base opacity-70 me-2"></i>Incarca o
                imagine</a>
              <a (click)="onDeleteImageClick()" ngbDropdownItem class="dropdown-item text-danger fw-normal"
                role="button"><i class="ai-trash fs-base me-2"></i>Sterge
                imagine</a>
            </div>
          </div>
          <div class="ps-3">
            <h3 class="h6 mb-1">Poza de profil</h3>
            <p class="fs-sm text-muted mb-0">PNG sau JPG nu mai mare de 1000px latime si inaltime.</p>
          </div>
        </div>

        <div *ngIf="pdfScriptsLoaded" ngbDropdown class="dropdown ms-auto pt-3 pt-sm-0">
          <button ngbDropdownToggle type="button" class="btn btn-secondary btn-sm dropdown-toggle">
            Exporta profil
          </button>
          <ul ngbDropdownMenu class="dropdown-menu my-1">
            <li><a ngbDropdownItem (click)="exportAsPdf()" class="dropdown-item" role="button">PDF</a></li>
            <li><a ngbDropdownItem (click)="exportAsExcel()" class="dropdown-item" role="button">Excel</a></li>
          </ul>
        </div>
      </div>

      <div class="row g-3 g-sm-4 mt-0 mt-lg-2">
        <div class="col-sm-6">
          <label class="form-label" for="firstName">Prenume</label>
          <input formControlName="firstName" [ngClass]="{'is-invalid': vs.hasErrors(form, 'firstName')}"
            class="form-control" type="text" placeholder="Prenume" id="firstName">
          <div class="invalid-feedback" *ngIf="vs.hasErrors(form, 'firstName')">{{vs.getError(form, 'firstName')}}
          </div>
        </div>
        <div class="col-sm-6">
          <label class="form-label" for="lastName">Nume</label>
          <input formControlName="lastName" [ngClass]="{'is-invalid': vs.hasErrors(form, 'lastName')}"
            class="form-control" type="text" placeholder="Nume" id="lastName">
          <div class="invalid-feedback" *ngIf="vs.hasErrors(form, 'lastName')">{{vs.getError(form, 'lastName')}}
          </div>
        </div>
        <div class="col-sm-6">
          <label class="form-label" for="email">Email</label>
          <input formControlName="email" [ngClass]="{'is-invalid': vs.hasErrors(form, 'email')}" class="form-control"
            type="email" placeholder="Email" id="email" readonly>
          <div class="invalid-feedback" *ngIf="vs.hasErrors(form, 'email')">{{vs.getError(form, 'email')}}
          </div>
        </div>
        <div class="col-sm-6">
          <label class="form-label" for="phone">Telefon <span class='text-muted'>(optional)</span></label>
          <input formControlName="phone" [ngClass]="{'is-invalid': vs.hasErrors(form, 'phone')}"
            (keypress)="onlyNumberKey($event)" class="form-control" type="tel" inputmode="tel"
            placeholder="07__ ___ ___" id="phone">
          <div class="invalid-feedback" *ngIf="vs.hasErrors(form, 'phone')">{{vs.getError(form, 'phone')}}
          </div>
        </div>
        <div *ngIf="!isCorporateUser(user)" class="col-sm-6">
          <label class="form-label" for="birthDate">Data nasterii</label>
          <input formControlName="birthDate" ngbDatepicker #datePicker="ngbDatepicker"
            [minDate]="{year: 1900, month:1, day: 1}"
            [maxDate]="{ year: currentDate.getFullYear() - 16, month: currentDate.getMonth() + 1, day: currentDate.getDate() }"
            (click)="datePicker.toggle()" [ngClass]="{'is-invalid': vs.hasErrors(form, 'birthDate')}"
            class="form-control" type="text" placeholder="Data nasterii (zz/ll/aaaa)" id="birthDate" readonly>
          <div class="invalid-feedback" *ngIf="vs.hasErrors(form, 'birthDate')">{{vs.getError(form, 'birthDate')}}
          </div>
        </div>
        <div class="col-sm-6">
          <label class="form-label" for="cityId">Localitate <span *ngIf="isCorporateUser(user)"
              class='text-muted'>(optional)</span></label>
          <ng-select formControlName="cityId" [items]="cities" [virtualScroll]="true" bindLabel="nameFormatted"
            bindValue="id" [ngClass]="{'is-invalid': vs.hasErrors(form, 'cityId')}" class="form-control"
            placeholder="Cauta numele localitatii (ex. Bucuresti)" id="cityId">
          </ng-select>
          <div class="invalid-feedback" *ngIf="vs.hasErrors(form, 'cityId')">{{vs.getError(form, 'cityId')}}
          </div>
        </div>
        <ng-container *ngIf="!isCorporateUser(user)">
          <div class="col-sm-6">
            <label class="form-label" for="gender">Gen <span class='text-muted'>(optional)</span></label>
            <select formControlName="gender" [ngClass]="{'is-invalid': vs.hasErrors(form, 'gender')}"
              class="form-select" id="gender">
              <option [ngValue]="null">Selecteaza gen</option>
              <option [ngValue]="1">Masculin</option>
              <option [ngValue]="2">Feminin</option>
            </select>
            <div class="invalid-feedback" *ngIf="vs.hasErrors(form, 'gender')">{{vs.getError(form, 'gender')}}
            </div>
          </div>
          <div class="col-sm-6">
            <label class="form-label" for="hobbyIds">Pasiuni <span class='text-muted'>(optional)</span></label>
            <ng-select formControlName="hobbyIds" [items]="hobbies" [multiple]="true" [closeOnSelect]="false"
              bindLabel="name" bindValue="id" [ngClass]="{'is-invalid': vs.hasErrors(form, 'hobbyIds')}"
              class="form-control" id="hobbyIds">
            </ng-select>
            <div class="invalid-feedback" *ngIf="vs.hasErrors(form, 'hobbyIds')">{{vs.getError(form, 'hobbyIds')}}
            </div>
          </div>
          <!-- <div class="col-12">
            <label class="form-label" for="description">Despre <span class='text-muted'>(optional)</span></label>
            <textarea formControlName="description" [ngClass]="{'is-invalid': vs.hasErrors(form, 'description')}"
              class="form-control" rows="5" id="description"></textarea>
            <div class="invalid-feedback" *ngIf="vs.hasErrors(form, 'description')">{{vs.getError(form, 'description')}}
            </div>
          </div> -->
        </ng-container>
        <div class="col-12 d-sm-flex align-items-center">
          <div class="form-check form-check-inline mb-0">
            <input formControlName="hasNewsletter" class="form-check-input" type="checkbox" id="hasNewsletter">
            <label class="form-check-label" for="hasNewsletter">Sunt de acord sa primesc comunicari din partea
              GiftShare</label>
          </div>

        </div>
        <div class="col-12 d-flex justify-content-end pt-3">
          <button [routerLink]="['/user/dashboard']" class="btn btn-secondary" type="button">Anuleaza</button>
          <button class="btn btn-primary ms-3" type="submit">Salveaza</button>
        </div>
      </div>
    </form>
  </div>
</section>


<!-- Billing details -->
<section *ngIf="!isCorporateUser(user)" class="card border-0 py-1 p-md-2 p-xl-3 p-xxl-4">
  <div class="card-body">
    <div class="d-flex align-items-center pb-4 mt-sm-n1 mb-0 mb-lg-1 mb-xl-3">
      <i class="ai-card text-primary lead pe-1 me-2"></i>
      <h2 class="h4 mb-0">Date de facturare</h2>
    </div>
    <div class="row row-cols-1 row-cols-md-2 g-4">

      <!-- Address PF -->
      <div *ngIf="personalAddress" class="col">
        <div class="card h-100 rounded-3 p-3 p-sm-4">
          <div class="d-flex align-items-center pb-2 mb-1">
            <h3 class="h6 text-nowrap text-truncate mb-0">{{personalAddress.firstName}} {{personalAddress.lastName}}
            </h3>
            <span class="badge bg-primary bg-opacity-10 text-primary fs-xs ms-3">Persoana fizica</span>
            <div class="d-flex ms-auto">
              <button (click)="onEditAddress(personalAddress)" class="nav-link fs-xl fw-normal py-1 pe-0 ps-1 ms-2"
                type="button" data-bs-toggle="tooltip" aria-label="Edit">
                <i class="ai-edit-alt"></i>
              </button>
            </div>
          </div>
          <p class="mb-0">{{personalAddress.street}}<br>{{getCity(personalAddress?.cityId)?.name || 'n/a'}},
            {{getCity(personalAddress?.cityId)?.countyName || 'n/a'}}</p>
          <div *ngIf="personalAddress?.isDefault" class="mt-2">
            <span class="badge bg-info bg-opacity-10 text-info">Adresa implicita</span>
          </div>
        </div>
      </div>

      <!-- Address PJ -->
      <div *ngIf="companyAddress" class="col">
        <div class="card h-100 rounded-3 p-3 p-sm-4">
          <div class="d-flex align-items-center pb-2 mb-1">
            <h3 class="h6 text-nowrap text-truncate mb-0">{{companyAddress.company}}</h3>
            <span class="badge bg-success bg-opacity-10 text-success fs-xs ms-3">Persoana juridica</span>
            <div class="d-flex ms-auto">
              <button (click)="onEditAddress(companyAddress)" class="nav-link fs-xl fw-normal py-1 pe-0 ps-1 ms-2"
                type="button" data-bs-toggle="tooltip" aria-label="Edit">
                <i class="ai-edit-alt"></i>
              </button>
              <!-- <button class="nav-link text-danger fs-xl fw-normal py-1 pe-0 ps-1 ms-2" type="button"
                data-bs-toggle="tooltip" aria-label="Delete" >
                <i class="ai-trash"></i>
              </button> -->
            </div>
          </div>
          <p class="mb-0">{{companyAddress?.street || 'n/a'}},<br>{{getCity(companyAddress?.cityId)?.name || 'n/a'}},
            {{getCity(companyAddress?.cityId)?.countyName || 'n/a'}}</p>
          <div *ngIf="companyAddress?.isDefault" class="mt-2">
            <span class="badge bg-info bg-opacity-10 text-info">Adresa implicita</span>
          </div>
        </div>
      </div>

      <div *ngIf="!companyAddress" class="col">
        <div class="card h-100 justify-content-center align-items-center border-dashed rounded-3 py-5 px-3 px-sm-4">
          <a (click)="onEditAddress()"
            class="stretched-link d-flex align-items-center fw-semibold text-decoration-none my-sm-3" role="button">
            <i class="ai-circle-plus fs-xl me-2"></i>
            Adauga persoana juridica
          </a>
        </div>
      </div>

    </div>

  </div>
</section>



<!--Image select  modal-->
<ng-template #imageModalTemplate let-modal>
  <div class="modal-header border-0">
    <h4 class="modal-title">Schimba imaginea</h4>
    <button (click)="modal?.dismiss()" class="btn-close" type="button" aria-label="Close"></button>
  </div>

  <div class="modal-body pt-0">
    <gs-image-crop [editedImage]="editedImage" [originalImage]="userDefaultImageUrl" type="user"
      (fileName)="onImageSelected($event)"></gs-image-crop>
  </div>

  <div class="modal-footer border-0">
    <button (click)="modal?.close()" class="btn btn-primary w-100 w-sm-auto ms-sm-3" type="button">OK</button>
  </div>
</ng-template>


<div [hidden]="true" #pdfExportView>
  <div class="table-row">
    <span class="table-label">Prenume:</span><span class="table-value">&nbsp;{{form.value.firstName}}</span>
  </div>

  <div class="table-row">
    <span class="table-label">Nume:</span><span class="table-value">&nbsp;{{form.value.lastName}}</span>
  </div>

  <div class="table-row">
    <span class="table-label">Email:</span><span class="table-value">&nbsp;{{form.value.email}}</span>
  </div>

  <div class="table-row">
    <span class="table-label">Localitate:</span><span class="table-value">&nbsp;{{form.value.city}}</span>
  </div>

  <div class="table-row">
    <span class="table-label">Gen:</span><span class="table-value">&nbsp;{{genderFormatted}}</span>
  </div>

  <div class="table-row">
    <span class="table-label">Data nasterii:</span><span class="table-value">&nbsp;{{form.value.birthDate |
      date:'dd/MM/yyyy'}}</span>
  </div>

  <div class="table-row">
    <span class="table-label">Telefon:</span><span class="table-value">&nbsp;{{form.value.phone}}</span>
  </div>

  <div class="table-row">
    <span class="table-label">Pasiuni:</span><span class="table-value">&nbsp;{{hobbiesFormatted}}</span>
  </div>
</div>
